/**
 * Optimized POA Handler - Single File Solution
 * Handles both styling and redirect functionality
 * Lightweight and fast - runs only when needed
 */

(function() {
  'use strict';

  // Only run if we're on a product page and variant table exists
  const variantTable = document.querySelector('.ai-variant-table__table-abevlzxv2cmorrmd6aaigenblockfece0fdhmc4ja, [class*="ai-variant-table"]');
  if (!variantTable) return;

  // Check if there are any POA variants on the page
  const poaElements = document.querySelectorAll('[data-is-poa="true"]');
  if (poaElements.length === 0) return;

  console.log('POA variants detected, initializing handler...');

  // Hide RRP prices that show $0.00
  function hideZeroRRPPrices() {
    // Handle both desktop table and mobile cards
    const rrpPrices = document.querySelectorAll(
      '.ai-variant-table__rrp-price-abevlzxv2cmorrmd6aaigenblockfece0fdhmc4ja, ' +
      '.ai-variant-card__rrp-price-abevlzxv2cmorrmd6aaigenblockfece0fdhmc4ja, ' +
      '[class*="__rrp-price-"]'
    );
    
    rrpPrices.forEach(price => {
      const text = price.textContent.trim();
      if (text === '$0.00' || text === '$0' || text === '0' || text === '') {
        price.style.visibility = 'hidden';
        console.log('Hidden RRP price showing:', text);
      }
    });
  }

  // Hide quantity controls for POA variants
  function hidePoaQuantityControls() {
    // Find all rows/cards with POA
    const poaContainers = document.querySelectorAll(
      'tr:has([data-is-poa="true"]), ' +
      '[class*="ai-variant-card"]:has([data-is-poa="true"]), ' +
      'tr[data-variant-id="41573399527522"], ' +
      'div[data-variant-id="41573399527522"]'
    );

    poaContainers.forEach(container => {
      // Find and hide quantity wrapper elements (keep space with visibility:hidden)
      const quantityWrappers = container.querySelectorAll(
        '.ai-variant-card__quantity-wrapper-abevlzxv2cmorrmd6aaigenblockfece0fdhmc4ja, ' +
        '.ai-variant-table__quantity-wrapper-abevlzxv2cmorrmd6aaigenblockfece0fdhmc4ja'
      );
      
      quantityWrappers.forEach(wrapper => {
        // Use visibility:hidden to preserve space/height
        wrapper.style.visibility = 'hidden';
        console.log('Hidden quantity control wrapper (preserving space)');
      });
    });
  }

  // Style POA text to match Our Price styling
  function stylePoaText() {
    const poaPrices = document.querySelectorAll('[data-is-poa="true"]');
    
    poaPrices.forEach(price => {
      if (price.textContent.trim() === 'POA') {
        price.style.cssText = 'color: #000000 !important; font-weight: 600 !important; font-size: 16px !important;';
        console.log('Styled POA text');
      }
    });
  }

  // Fix POA card structure to match working cards
  function fixPoaCardStructure() {
    // Find all mobile POA cards
    const poaCards = document.querySelectorAll('[class*="ai-variant-card"]');
    
    poaCards.forEach(card => {
      // Find the broken prices element that has data-is-poa directly on it
      const brokenPriceDiv = card.querySelector('.ai-variant-card__prices-abevlzxv2cmorrmd6aaigenblockfece0fdhmc4ja[data-is-poa="true"]');
      
      if (brokenPriceDiv && !brokenPriceDiv.hasAttribute('data-structure-fixed')) {
        console.log('Found broken POA card structure, fixing...');
        
        // Mark as fixed to prevent re-processing
        brokenPriceDiv.setAttribute('data-structure-fixed', 'true');
        
        // Save the POA text
        const poaText = brokenPriceDiv.textContent.trim();
        
        // Clear the broken structure
        brokenPriceDiv.innerHTML = '';
        brokenPriceDiv.removeAttribute('data-is-poa');
        brokenPriceDiv.removeAttribute('data-original-price');
        brokenPriceDiv.removeAttribute('style');
        
        // Create RRP div (hidden but taking space like working cards)
        const rrpDiv = document.createElement('div');
        rrpDiv.className = 'ai-variant-card__rrp-price-abevlzxv2cmorrmd6aaigenblockfece0fdhmc4ja';
        rrpDiv.style.visibility = 'hidden';
        rrpDiv.textContent = '$0.00';
        
        // Create price div with POA
        const priceDiv = document.createElement('div');
        priceDiv.className = 'ai-variant-card__price-abevlzxv2cmorrmd6aaigenblockfece0fdhmc4ja';
        priceDiv.setAttribute('data-is-poa', 'true');
        priceDiv.style.cssText = 'color: #000000 !important; font-weight: 600 !important; font-size: 16px !important;';
        priceDiv.textContent = poaText;
        
        // Add both elements to the container
        brokenPriceDiv.appendChild(rrpDiv);
        brokenPriceDiv.appendChild(priceDiv);
        
        // Now add an empty quantity wrapper to preserve spacing
        const cardInner = card.querySelector('.ai-variant-card__inner-abevlzxv2cmorrmd6aaigenblockfece0fdhmc4ja');
        
        if (cardInner) {
          // Check if quantity wrapper already exists (and is hidden)
          let outerQuantityWrapper = card.querySelector('.ai-variant-card__quantity-wrapper-abevlzxv2cmorrmd6aaigenblockfece0fdhmc4ja');
          
          if (!outerQuantityWrapper) {
            // Create nested quantity wrapper structure matching working cards
            outerQuantityWrapper = document.createElement('div');
            outerQuantityWrapper.className = 'ai-variant-card__quantity-wrapper-abevlzxv2cmorrmd6aaigenblockfece0fdhmc4ja';
            
            // Create inner wrapper
            const innerQuantityWrapper = document.createElement('div');
            innerQuantityWrapper.className = 'ai-variant-table__quantity-wrapper-abevlzxv2cmorrmd6aaigenblockfece0fdhmc4ja';
            
            // Add dummy content to maintain height (hidden but present)
            innerQuantityWrapper.innerHTML = `
              <button type="button" class="ai-variant-table__quantity-btn-abevlzxv2cmorrmd6aaigenblockfece0fdhmc4ja" style="visibility:hidden" aria-hidden="true">-</button>
              <input type="number" class="ai-variant-table__quantity-input-abevlzxv2cmorrmd6aaigenblockfece0fdhmc4ja" value="1" style="visibility:hidden" aria-hidden="true">
              <button type="button" class="ai-variant-table__quantity-btn-abevlzxv2cmorrmd6aaigenblockfece0fdhmc4ja" style="visibility:hidden" aria-hidden="true">+</button>
            `;
            
            outerQuantityWrapper.appendChild(innerQuantityWrapper);
            
            // Insert it before the button
            const button = cardInner.querySelector('button');
            if (button) {
              cardInner.insertBefore(outerQuantityWrapper, button);
              console.log('Added nested quantity wrapper structure for spacing');
            }
          } else {
            // Quantity wrapper exists - make sure it has proper height and is only hidden
            outerQuantityWrapper.style.cssText = 'visibility: hidden !important; min-height: 48px !important;';
            
            // Make sure inner wrapper also preserves its natural height
            const innerWrapper = outerQuantityWrapper.querySelector('.ai-variant-table__quantity-wrapper-abevlzxv2cmorrmd6aaigenblockfece0fdhmc4ja');
            if (innerWrapper) {
              innerWrapper.style.cssText = 'visibility: hidden !important; min-height: 48px !important;';
            }
            
            console.log('Updated existing quantity wrapper for spacing with min-height');
          }
        }
        
        console.log('Fixed POA card structure to match working cards');
      }
    });
  }

  // Initialize contact redirect functionality
  function initContactRedirect() {
    // Find all POA buttons (desktop table + mobile cards)
    // Be very specific - only target Add to Cart buttons, NOT quantity buttons
    const poaButtons = document.querySelectorAll(
      // Desktop table selectors (Add to Cart buttons only)
      'tr:has([data-is-poa="true"]) button[data-add-to-cart]:not([data-action]), ' +
      'tr[data-variant-id="41573399527522"] button[data-add-to-cart]:not([data-action]), ' +
      // Mobile card selectors (Add to Cart buttons only, not quantity buttons)
      '.ai-variant-card-abevlzxv2cmorrmd6aaigenblockfece0fdhmc4ja:has([data-is-poa="true"]) > .ai-variant-card__inner-abevlzxv2cmorrmd6aaigenblockfece0fdhmc4ja > button, ' +
      '.ai-variant-card-abevlzxv2cmorrmd6aaigenblockfece0fdhmc4ja:has([data-is-poa="true"]) button[data-add-to-cart-grid]:not([data-action]), ' +
      '.ai-variant-card-abevlzxv2cmorrmd6aaigenblockfece0fdhmc4ja:has([data-is-poa="true"]) .ai-variant-card__add-btn-abevlzxv2cmorrmd6aaigenblockfece0fdhmc4ja, ' +
      'div[data-variant-id="41573399527522"] > .ai-variant-card__inner-abevlzxv2cmorrmd6aaigenblockfece0fdhmc4ja > button, ' +
      'div[data-variant-id="41573399527522"] button[data-add-to-cart-grid]:not([data-action]), ' +
      '[class*="ai-variant-card"]:has([data-is-poa="true"]) button.ai-variant-card__add-btn-abevlzxv2cmorrmd6aaigenblockfece0fdhmc4ja, ' +
      '[class*="ai-variant-card"]:has([data-is-poa="true"]) button.ai-variant-table__add-btn-abevlzxv2cmorrmd6aaigenblockfece0fdhmc4ja'
    );

    if (poaButtons.length === 0) {
      console.log('No POA buttons found');
      return;
    }

    console.log(`Found ${poaButtons.length} POA button(s)`);

    poaButtons.forEach((button, index) => {
      // Skip if already processed
      if (button.hasAttribute('data-poa-processed')) return;
      
      // Skip if it's a quantity button (has data-action attribute)
      if (button.hasAttribute('data-action')) return;
      
      // Skip if it's inside a quantity wrapper
      if (button.closest('[class*="quantity-wrapper"]')) return;
      
      button.setAttribute('data-poa-processed', 'true');

      // Change button type and remove cart attributes
      button.setAttribute('type', 'button');
      button.removeAttribute('data-add-to-cart');
      button.removeAttribute('data-add-to-cart-grid');
      
      // Directly change button text and styling
      button.textContent = 'Contact Us';
      button.style.cssText = 'background-color: #2e2e2e !important; color: #ffffff !important; cursor: pointer !important; border: none !important; padding: 10px 20px !important; font-size: 14px !important; font-weight: 600 !important;';
      
      // Add data attribute for CSS targeting
      button.setAttribute('data-poa-contact-btn', 'true');

      // Add click handler with high priority
      button.addEventListener('click', handleContactRedirect, true);
      
      console.log(`POA button ${index + 1} initialized`);
    });
  }

  function handleContactRedirect(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    console.log('Contact Us button clicked - redirecting...');

    // Get row or card context
    const row = this.closest('tr');
    const card = this.closest('[class*="ai-variant-card"]');
    const context = row || card;

    if (!context) {
      console.error('Could not find context for button');
      return false;
    }

    // Extract variant information
    const variantTitle = context.querySelector('[class*="__title-"]')?.textContent.trim() || '';
    const sku = context.querySelector('[class*="__code-"]')?.textContent.trim() || '';
    const productTitle = document.querySelector('.product__title, h1')?.textContent.trim() || 'this product';

    // Build message
    let message = `I am enquiring about ${productTitle}`;
    if (variantTitle && variantTitle !== productTitle) {
      message += ` - ${variantTitle}`;
    }
    if (sku) {
      message += ` (SKU: ${sku})`;
    }
    message += '.';

    console.log('Message:', message);

    // Redirect
    const encodedMessage = encodeURIComponent(message);
    window.location.href = `/pages/contact?message=${encodedMessage}`;

    return false;
  }

  // Initialize immediately
  fixPoaCardStructure();
  hideZeroRRPPrices();
  hidePoaQuantityControls();
  stylePoaText();
  initContactRedirect();

  // Also watch for dynamic content (debounced for performance)
  let timeoutId;
  const observer = new MutationObserver(() => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      fixPoaCardStructure();
      hideZeroRRPPrices();
      hidePoaQuantityControls();
      stylePoaText();
      initContactRedirect();
    }, 100);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  console.log('POA handler fully initialized');
})();